// extracted by mini-css-extract-plugin
export default {"menu":"MenuBar_menu__lf6z5"};